<page-headline
    [module]="'financials'"
    [moduleIcon]="'fa-dollar-sign'"
    [moduleLink]="'financials/insights/'"
    [pageTitle]="'Compensation Snapshot'"
    [linkTitle]="'Financials Insights'"
>
</page-headline>
<div class="pay-options">
    <div class="pay-options-left">
        <div class="pay-options-regions" *ngIf="hasRegions">
            <div class="pay-regions-text">Region:</div>
            <angular2-multiselect
                [data]="regions"
                [(ngModel)]="selectedRegion"
                [settings]="regionListSettings"
                (onSelect)="onRegionSelect($event)"
                style="width: 200px"
            >
            </angular2-multiselect>
        </div>
        <div class="pay-options-branches" *ngIf="hasBranches">
            <div class="pay-branches-text">Branch:</div>
            <angular2-multiselect
                [data]="branches"
                [(ngModel)]="selectedBranch"
                [settings]="branchListSettings"
                (onSelect)="onBranchSelect($event)"
                style="width: 200px"
            >
            </angular2-multiselect>
        </div>
        <div class="pay-options-employees">
            <div class="pay-employees-text">Employee:</div>
            <angular2-multiselect
                [data]="employees"
                [(ngModel)]="selectedEmployee"
                [settings]="employeeListSettings"
                (onSelect)="onEmployeeSelect($event)"
                style="width: 200px"
            >
            </angular2-multiselect>
        </div>
    </div>
    <div class="pay-options-right">
        <div class="pay-calendar">
            <div class="pay-calendar-text">Pay Calendar:</div>
            <angular2-multiselect
                [data]="calendarTypes"
                [(ngModel)]="selectedCalendarItem"
                [settings]="payrollCalendarSettings"
                (onSelect)="onCalendarSelect($event)"
                style="width: 200px"
            >
            </angular2-multiselect>
        </div>
        <div class="pay-period">
            <div class="pay-period-text">Pay Date:</div>
            <button (click)="clickPreviousPeriod()"><</button>
            <div class="card flex justify-center">
                <p-select
                    [options]="payrollPeriods"
                    [virtualScroll]="true"
                    [virtualScrollItemSize]="42"
                    [(ngModel)]="selectedPayrollPeriod"
                    optionLabel="payDate"
                    placeholder="Select a Period"
                    class="select-box w-full md:w-56"
                />
            </div>
            <button (click)="clickNextPeriod()">></button>
        </div>
    </div>
</div>
<div class="comp-snapshot-charts">
    <div class="comp-snapshot-left">
        <div style="margin-top: 40px; margin-bottom: 40px">
            <custom-mat-table
                [customTableInfo]="customTableInfo"
                (cellClickedEvent)="cellClickedEvent($event)"
            ></custom-mat-table>
        </div>
        <div class="waterfall-large-card">
            <large-card
                [largeCardInteriorOptions]="waterfallChart.largeCardInteriorOptions"
            ></large-card>
        </div>
    </div>
    <div class="comp-snapshot-right">
        <div
            class="smallCards"
            [ngStyle]="{ 'flex-wrap': smallCards.length === 2 ? 'nowrap' : 'wrap' }"
        >
            <div *ngFor="let smallCard of smallCards" class="small-card">
                <small-card
                    [smallCardData]="smallCard.card"
                    [isUnclickable]="true"
                    *ngIf="smallCard.card"
                ></small-card>
            </div>
        </div>
    </div>
</div>
